import { useEffect, useState } from "react";

const LivelinessTest = () => {
    const [token, setToken] = useState("");
    const [sdkData, setSdkData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [clientKey, setClientKey] = useState("");
    const [scriptUrl, setScriptUrl] = useState("");


    const handleSDKData = (data) => {
        setSdkData(data);
    };

    const handleGetTokenAndSDKInit = () => {
        if (!clientKey || !scriptUrl) {
            alert("Please provide both the Client Key and Script URL.");
            return;
        }

        setLoading(true);

        // let TenantId = tenantId || "defaultTenantId"; // Replace with actual Tenant ID if needed
        // let LeadId = leadId || "defaultLeadId"; // Replace with actual Lead ID if needed

        const apiUrl = `https://8z3gyr1r91.execute-api.ap-south-1.amazonaws.com/default/test_token_face_liveliness?RefId=4567890&Redirect_url=https://uat.agent.ainxtapi.com/&client_key=${clientKey}`;

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": "HUkpbjvfmb4TQGfdLLtD4ct8Pm65nS2Qms5lTUTf",
            },
        };

        fetch(apiUrl, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setToken(data.Token);
                window.AinxtSDK.Initialize(data.Token, handleSDKData);
            })
            .catch((error) => {
                console.error("Error fetching token:", error);
            })
            .finally(() => {
                setLoading(false);
            });

        // const myHeaders = new Headers();
        // myHeaders.append("x-api-key", "SPFPEqK9rwayWPZcB6yhP6dAxbf24HIh3ivaHAGR");
        // myHeaders.append("Content-Type", "application/json");

        // const raw = JSON.stringify({
        //     "source": "saas",
        //     "tenantId": "123",
        //     "leadId": "4567"
        // });

        // const requestOptions = {
        //     method: "POST",
        //     headers: myHeaders,
        //     body: raw,
        //     redirect: "follow"
        // };

        // fetch("https://token-generation-uat.ainxtapi.com/uat/generate-token", requestOptions)
        //     .then((response) => response.json())
        //     .then((result) => {
        //         // console.log(result)
        //         window.AinxtSDK.Initialize(result.token, handleSDKData);
        //     })
        //     .catch((error) => console.error(error));

    };

    useEffect(() => {
        if (scriptUrl) {
            const script = document.createElement("script");
            script.src = scriptUrl;
            script.async = true;

            document.head.appendChild(script);

            return () => {
                document.head.removeChild(script);
            };
        }
    }, [scriptUrl]); // Dependency on scriptUrl

    return (
        <div className="text-center">
            <h1 style={{ color: "white" }} className="text-4xl font-bold mb-8">
                Face LIVELINESS SDK Test 1
            </h1>

            <div className="mb-4">
                {/* <input
                        type="text"
                        placeholder="Enter Tenant ID"
                        value={tenantId}
                        onChange={(e) => setTenantId(e.target.value)}
                        className="form-control mb-2"
                        style={{
                            padding: "10px",
                            width: "300px",
                            margin: "10px auto",
                            display: "block",
                            borderRadius: "5px",
                        }}
                    />
                     <input
                        type="text"
                        placeholder="Enter lead ID"
                        value={leadId}
                        onChange={(e) => setLeadId(e.target.value)}
                        className="form-control mb-2"
                        style={{
                            padding: "10px",
                            width: "300px",
                            margin: "10px auto",
                            display: "block",
                            borderRadius: "5px",
                        }}
                    /> */}

                <input
                    type="text"
                    placeholder="Enter Client Key"
                    value={clientKey}
                    onChange={(e) => setClientKey(e.target.value)}
                    className="form-control mb-2"
                    style={{
                        padding: "10px",
                        width: "300px",
                        margin: "10px auto",
                        display: "block",
                        borderRadius: "5px",
                    }}
                />
                <input
                    type="text"
                    placeholder="Enter Script URL"
                    value={scriptUrl}
                    onChange={(e) => setScriptUrl(e.target.value)}
                    className="form-control"
                    style={{
                        padding: "10px",
                        width: "300px",
                        margin: "10px auto",
                        display: "block",
                        borderRadius: "5px",
                    }}
                />
            </div>

            <button
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                onClick={handleGetTokenAndSDKInit}
                disabled={loading}
                style={{
                    background: "linear-gradient(90deg, #5e24a0, #9e6dd5)",
                }}
            >
                {loading ? "Loading..." : "Get Token & Initialize AinxtSDK"}
            </button>

            {sdkData && (
                <div className="mt-4">
                    <h2 style={{ color: "black" }} className="text-xl font-bold mb-2">
                        Data from SDK :
                    </h2>
                    <pre style={{ color: "black" }} className="whitespace-pre-wrap">
                        {JSON.stringify(sdkData, null, 2)}
                    </pre>
                </div>
            )}
        </div>
    );
};

export default LivelinessTest;







// ONLY SAAS JOURNY

// import { useEffect, useState } from "react";

// const LivelinessTest = () => {
//     const [sdkData, setSdkData] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [clientKey, setClientKey] = useState("");
//     const [scriptUrl, setScriptUrl] = useState("");


//     const handleSDKData = (data) => {
//         setSdkData(data);
//     };

//     const handleGetTokenAndSDKInit = () => {
//         if (!clientKey || !scriptUrl) {
//             alert("Please provide both the Client Key and Script URL.");
//             return;
//         }

//         setLoading(true);


//         const myHeaders = new Headers();
//         myHeaders.append("x-api-key", "SPFPEqK9rwayWPZcB6yhP6dAxbf24HIh3ivaHAGR");
//         myHeaders.append("Content-Type", "application/json");

//         const raw = JSON.stringify({
//             "source": "saas",
//             "tenantId": "123",
//             "leadId": "4567",
//             "clientId": clientKey
//         });

//         const requestOptions = {
//             method: "POST",
//             headers: myHeaders,
//             body: raw,
//             redirect: "follow"
//         };

//         fetch("https://token-generation-uat.ainxtapi.com/uat/generate-token", requestOptions)
//             .then((response) => response.json())
//             .then((result) => {
//                 if (result.error) {
//                     alert(result.error)
//                     setLoading(false)
//                     return
//                 } else {
//                     window.AinxtSDK.Initialize(result.token, handleSDKData);
//                 }
//             })
//             .catch((error) => console.error(error))
//             .finally(() => {
//                 setLoading(false);
//             })

//     };

//     useEffect(() => {
//         if (scriptUrl) {
//             const script = document.createElement("script");
//             script.src = scriptUrl;
//             script.async = true;
//             document.head.appendChild(script);
//             return () => {
//                 document.head.removeChild(script);
//             };
//         }
//     }, [scriptUrl]); // Dependency on scriptUrl

//     return (
//         <div className="text-center">
//             <h1 style={{ color: "white" }} className="text-4xl font-bold mb-8">
//                 Face LIVELINESS SDK Test
//             </h1>

//             <div className="mb-4">
//                 <input
//                     type="text"
//                     placeholder="Enter Client Key"
//                     value={clientKey}
//                     onChange={(e) => setClientKey(e.target.value)}
//                     className="form-control mb-2"
//                     style={{
//                         padding: "10px",
//                         width: "300px",
//                         margin: "10px auto",
//                         display: "block",
//                         borderRadius: "5px",
//                     }}
//                 />
//                 <input
//                     type="text"
//                     placeholder="Enter Script URL"
//                     value={scriptUrl}
//                     onChange={(e) => setScriptUrl(e.target.value)}
//                     className="form-control"
//                     style={{
//                         padding: "10px",
//                         width: "300px",
//                         margin: "10px auto",
//                         display: "block",
//                         borderRadius: "5px",
//                     }}
//                 />
//             </div>

//             <button
//                 className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
//                 onClick={handleGetTokenAndSDKInit}
//                 disabled={loading}
//                 style={{
//                     background: "linear-gradient(90deg, #5e24a0, #9e6dd5)",
//                 }}
//             >
//                 {loading ? "Loading..." : "Get Token & Initialize AinxtSDK"}
//             </button>

//             {sdkData && (
//                 <div className="mt-4">
//                     <h2 style={{ color: "white" }} className="text-xl font-bold mb-2">
//                         Data from SDK:
//                     </h2>
//                     <pre style={{ color: "white" }} className="whitespace-pre-wrap">
//                         {JSON.stringify(sdkData, null, 2)}
//                     </pre>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default LivelinessTest;